import { ChannelStatus } from '@/models/channels'

const memberChannels = state => state.memberChannels

const memberActiveChannels = state =>
  state.memberChannels.filter(
    channel => channel.status === ChannelStatus.ACTIVE
  )

const memberArchivedChannels = state =>
  state.memberChannels.filter(
    channel => channel.status === ChannelStatus.ARCHIVED
  )

export default {
  memberChannels,
  memberActiveChannels,
  memberArchivedChannels
}
